<template>
  <div class="u-m3" v-loading="loading">
    <form @submit.prevent="createPaymentMethod">
      <div :id="paymentElementMountNodeId"></div>
      <div v-if="errorMessage" class="u-warning">
        <i class="material-icons md-text" aria-hidden="true">warning</i> {{ errorMessage }}
      </div>
      <div class="u-mt3">
        <el-button type="primary" nativeType="submit" >{{ t('payments.save_payment_method') }}</el-button>
      </div>
    </form>
  </div>

</template>

<script>

import { mapActions } from 'vuex'
import { loadStripe } from '@stripe/stripe-js'
import { sleep } from '@shared_src/utils/misc.util'

export default {
  name: 'r-ba-add-payment-method-stripe',
  props: ['insuredId', 'stripeSetupData'],
  data () {
    let rndID = Math.round(Math.random() * 1000).toString()
    return {
      paymentElementMountNodeId: 'payment-element' + rndID,
      stripe: null,
      cardElement: null,
      paymentElement: null,
      elements: null,
      errorMessage: '',
      clientSecret: null,
      submitButtonVisible: false,
      loading: false
    }
  },
  methods: {
    ...mapActions('payments', [
      'retrievePaymentMethodCreationDetails', 'createPaymentMethodPoll', 'getPaymentMethodPoll',
      'getOwnedPaymentMethods']),
    async createPaymentMethod () {
      let confirmStripeSetupResult
      this.loading = true
      try {
        confirmStripeSetupResult = await this.stripe.confirmSetup({
          elements: this.elements,
          confirmParams: {
            return_url: window.location.href,
          },
          redirect: 'if_required'
        })
        if (confirmStripeSetupResult.error) {
          this.loading = false
          console.error('Stripe confirmSetup error:', confirmStripeSetupResult)
          if (confirmStripeSetupResult.error.type === 'validation_error') {
            this.$elAlert(confirmStripeSetupResult.error.message, this.t('global.error'))
          } else {
            this.$elAlert('Error on payment processor side during payment method add!', this.t('global.error'))
          }

          return
        }
      } catch (e) {
        console.error('Error while calling Stripe confirmSetup:', e)
        this.loading = false
        this.errorMessage = 'Generic error during payment method add!'
        return
      }

      if (confirmStripeSetupResult.setupIntent.status !== 'succeeded') {
        this.loading = false
        this.$elAlert('Somethng wend wrong during payment method add! Status is not "succeeded"',
          this.t('global.error'))
        return
      }

      let createPaymentMethodPollResult
      try {
        createPaymentMethodPollResult = await this.createPaymentMethodPoll({
          insured_id: this.insuredId,
          pm_vendor_id: confirmStripeSetupResult.setupIntent.payment_method,
          pm_timestamp: confirmStripeSetupResult.setupIntent.created,
        })
      } catch (e) {
        this.loading = false
        this.$elAlert('Error during Payment method request-poll operation', this.t('global.error'))
        return
      }

      let createPaymentMethodPollResultData = createPaymentMethodPollResult
      this.loading = false
      if (!createPaymentMethodPollResultData.success) {
        this.$elAlert('Unsuccessful call during Payment method request-poll operation', this.t('global.error'))
        return
      }
      // call next method in chain without await
      this.waitForNewPaymentMethod(createPaymentMethodPollResultData.data.poll_id)
    },
    async waitForNewPaymentMethod (pollId) {
      this.loading = true
      let getPaymentMethodPollResult
      let n = 0
      while (n < 30) {
        // 30 calls is something around 90+ seconds poll.
        // If we don't have info in this period of time - something went wrong
        try {
          getPaymentMethodPollResult = await this.getPaymentMethodPoll(pollId)
        } catch (e) {
          this.errorMessage = 'Error during Payment method get-request-poll operation'
          return
        }
        if (getPaymentMethodPollResult.data.payment_method_id) {
          this.$emit('paymentMethodAdded')
          await this.getOwnedPaymentMethods()
          this.loading = false
          return
        }
        await sleep(3000)  // call each 3 seconds, it's very lightweight call
        n = n + 1
      }
      this.loading = false
      this.$elAlert('Failed to retrieve new payment method', this.t('global.error'))
    },
  },
  async mounted () {
    this.loading = true
    try {
      try {
        this.stripe = await loadStripe(this.stripeSetupData.publishable_key, {
          stripeAccount: this.stripeSetupData.stripe_account,
        })
      } catch (error) {
        console.error('Error loading Stripe:', error)
        this.errorMessage = 'Failed to load payment processor.'
        return
      }

      let appearance = { /* appearance */ }
      let options = {
        layout: {
          type: 'tabs',
          defaultCollapsed: false,
        },
        wallets: {
          link: 'never'
        }
      }

      this.clientSecret = this.stripeSetupData.client_secret
      this.elements = this.stripe.elements({clientSecret: this.clientSecret, appearance})
      this.paymentElement = this.elements.create('payment', options)
      await this.paymentElement.mount('#' + this.paymentElementMountNodeId)
      this.submitButtonVisible = true
    } finally {
      this.loading = false
    }
  },
}
</script>
